import { IPourStatus } from "@/models";

export enum ROUTES {
  HOME = '/',
  NOT_FOUND = '*',
  LOGIN = '/login',
  PROJECTS = '/projects',
  PROJECT = '/projects/:id',
  PROJECT_STATUS = '/projects/status/:projectId', // Adjusted this line
  ADD_POUR = '/add-pour/:projectId',
  EDIT_POUR = '/edit-pour/:projectId/:pourId',
  EDIT_SENSOR = '/edit-sensor/:projectId/:pourId/:pourStatus/:sensorId',
  ADD_HUB = '/add-hub/:projectName/:projectId',
  EDIT_HUB = '/edit-hub/:projectId/:hubId',
  SENSORS = '/sensors/:projectId/:pourId',
  SENSOR = '/sensors/sensor-details/:projectId/:pourId/:sensorName/:sensorId',
  ADD_SENSOR = '/add-sensor/:projectId',
  ADD_SENSOR_BY_NAME = '/add-sensor-by-name/:projectId',
  UPSERT_DEVICE = '/upsert-device/:projectId/:pourId/:pourStatus',
  SETTINGS = '/settings',
  CHARTS = '/charts',
  MAINTENANCE_MODE = '/maintenance-mode',
  MATURITY_CALIBRATION = '/maturity-calibration',
  MATURITY_CONCRETE_PRESSES = '/maturity-calibration/concrete/:concreteId',
}

export const routesDetails = {
  addPour: (projectId: string) => `/add-pour/${projectId}`,
  editPour: (projectId: string, pourId: number, enableEditBtype: boolean) =>
    `/edit-pour/${projectId}/${pourId}?enableEditBtype=${enableEditBtype}`,
  editSensor: (sensorId: string,projectId: string, pourId: string, pourStatus:string) =>
    `/edit-sensor/${projectId}/${pourId}/${pourStatus}/${sensorId}`,
  project: (projectId: string, isOneProject?: boolean) =>
    `/projects/${projectId}?single=${isOneProject ? 'true' : 'false'}`,
  Sensors: (
    projectId: string,
    pourId: string,
    pourStatus: IPourStatus
  ) => `/sensors/${projectId}/${pourId}?pourStatus=${pourStatus}`,
  Sensor: (
    projectId: string,
    pourId: string,
    sensorId: string,
    sensorName: string,
    pourStatus: IPourStatus
  ) =>
    `/sensors/sensor-details/${projectId}/${pourId}/${sensorName}/${sensorId}/?pourStatus=${pourStatus}`,
  addHub: (projectId: string, projectName: string) =>
    `/add-hub/${projectName}/${projectId}`,
  editHub: (hubId: string,projectId: string) =>
    `/edit-hub/${projectId}/${hubId}`,
  addSensor: (projectId: string, pourId?: string, isWithQR?: boolean) => {
    let url = `/add-sensor/${projectId}`;
    if (pourId) {
      url += `?pourId=${pourId}`;
    }
    if (isWithQR) {
      url += (pourId ? '&' : '?') + `withQR=true`;
    }
    return url;
  },
  addSensorByName: (projectId: string, pourId?: string) =>
  pourId !== undefined
    ? `/add-sensor-by-name/${projectId}?pourId=${pourId}`
    : `/add-sensor-by-name/${projectId}`,

  ProjectStatus: (projectId: string) => `/projects/status/${projectId}`,

  UpsertDevice: (projectId: string, pourId: string,pourStatus:string, sensorId?:string, bananaId?:string, switchDevice: boolean = false) =>
    switchDevice
        ? `/upsert-device/${projectId}/${pourId}/${pourStatus}?SwitchDevice=${switchDevice}&sensorId=${sensorId}&bananaId=${bananaId}`
        : `/upsert-device/${projectId}/${pourId}/${pourStatus}?SwitchDevice=${switchDevice}`,

  maturityConcretePress: (concreteId: number) => `/maturity-calibration/concrete/${concreteId}`,
};
